// src/pages/SubmitLink.js
import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SuccessOverlay = ({ open }) => (
  <Grow in={open} timeout={500}>
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1500,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: 4,
          borderRadius: 2,
          textAlign: 'center',
          boxShadow: 24,
        }}
      >
        <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        <Typography variant="h3" color="success.main">
          Success
        </Typography>
        <Typography variant="h5" sx={{ mt: 1 }}>
          Link submitted successfully!
        </Typography>
      </Box>
    </Box>
  </Grow>
);

const SubmitLink = () => {
  const [link, setLink] = useState("");
  const [user, setUser] = useState("");
  const [fullScreen, setFullScreen] = useState(false);
  const [endingMood, setEndingMood] = useState(false);
  const [lifeTime, setLifeTime] = useState(1);

  // ⭐ NUEVO
  const [cat, setCat] = useState("");
  const [customCat, setCustomCat] = useState("");

  const [status, setStatus] = useState(null);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);

  const categories = [
    "Backing Track",
    "Drum Track",
    "Fun",
    "BJamShutDown",
    "Interview",
    "Infomative",
    "Shaun Track and famous",
    "YoutubeShort",
    "UnrelatedToMusic"

  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValidYouTube = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(link);
    if (!isValidYouTube) {
      setStatus({ type: "error", message: "Please enter a valid YouTube link." });
      return;
    }

    const lifeTimeValue = parseInt(lifeTime, 10);
    if (isNaN(lifeTimeValue) || lifeTimeValue <= 0) {
      setStatus({ type: "error", message: "LifeTime must be a number greater than 0." });
      return;
    }

    const finalCategory = cat === "__custom__" ? customCat.trim() : cat;

    try {
      const payload = {
        youtubeLink: link,
        user: user || "Anonymous",
        fullScreen: fullScreen,
        endingMood: endingMood,
        lifeTime: lifeTimeValue,
        cat: finalCategory, // ⭐ NUEVO EN PAYLOAD
      };

      const response = await fetch("https://netofcomputers.com:3090/tbotw/ytLink", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Server responded with an error");
      }

      setShowSuccessOverlay(true);
      setStatus(null);

      setTimeout(() => {
        setShowSuccessOverlay(false);
      }, 3000);

      setLink("");
      setUser("");
      setFullScreen(false);
      setEndingMood(false);
      setLifeTime(1);
      setCat("");
      setCustomCat("");

    } catch (error) {
      console.error("Submission error:", error);
      setStatus({
        type: "error",
        message: "There was an error submitting the link. Try again later.",
      });
      setShowSuccessOverlay(false);
    }
  };

  return (
    <>
      <SuccessOverlay open={showSuccessOverlay} />

      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Typography variant="h4" gutterBottom>
          🎧 Track para los enemigos
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Pega el link a un video de youtube
        </Typography>

        {status && (
          <Alert severity={status.type} sx={{ mb: 3 }}>
            {status.message}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            label="YouTube Link"
            variant="outlined"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            sx={{ mb: 3 }}
          />

          <TextField
            fullWidth
            label="Your Name (always the same)"
            variant="outlined"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            sx={{ mb: 3 }}
            placeholder="Anonymous"
          />

          <FormGroup sx={{ mb: 3 }}>
            <FormControlLabel
              control={<Checkbox checked={fullScreen} onChange={(e) => setFullScreen(e.target.checked)} />}
              label="Reproducir en Pantalla Completa"
            />
            <FormControlLabel
              control={<Checkbox checked={endingMood} onChange={(e) => setEndingMood(e.target.checked)} />}
              label="Marcar si el video es para cerrar la bjam"
            />
          </FormGroup>

          <TextField
            fullWidth
            required
            label="Reproducciones máximas"
            variant="outlined"
            type="number"
            inputProps={{ min: 1 }}
            value={lifeTime}
            onChange={(e) => setLifeTime(e.target.value)}
            sx={{ mb: 4 }}
            helperText="Number of times the video can be played before being deleted."
          />

          {/* ⭐ NUEVO DROPDOWN */}
          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel>Category</InputLabel>
            <Select
              value={cat}
              label="Category"
              onChange={(e) => setCat(e.target.value)}
            >
              {categories.map((c) => (
                <MenuItem key={c} value={c}>{c}</MenuItem>
              ))}
              <MenuItem value="__custom__">Write my own…</MenuItem>
            </Select>
          </FormControl>

          {cat === "__custom__" && (
            <TextField
              fullWidth
              label="Custom Category"
              value={customCat}
              onChange={(e) => setCustomCat(e.target.value)}
              sx={{ mb: 3 }}
            />
          )}

          <Button variant="contained" type="submit" fullWidth disabled={showSuccessOverlay}>
            Submit Link
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default SubmitLink;
